import React from "react";
import { connect } from "react-redux";
import { authContext } from "../../auth";
import {
  Header,
  Flex,
  Button,
  AcceptIcon
} from "@fluentui/react-northstar";
import translate from "../../i18n/translate";
import {
  getAdminConsentUrl,
  ConsentccUrl,
  ConsentpresenceUrl,
  ConsentReportsUrl,
  ConsentAgentConsoleUrl,
  ConsentAgentConsoleUnifyUrl,
  ConsentAgentConsoleEuropeUrl,
} from "../../urls";
const presenceAPp = "b49547c3-196e-4e6b-a4c0-a4deea391db0";
const reportsApp = "2648d652-0325-425a-88a4-fd99068b32a8";
const agentConsoleApp = "f3ad2154-7e10-4730-a055-8852ced42d47";
const agentConsoleUnifyApp = "13dc7c3d-b71b-4568-a68e-ac31df943617";
const agentConsoleEuropeApp = "d42ccc26-e663-42bf-be39-4631345ad45e";
const contactCenterApp = "2ad91f01-bf93-4313-89f1-cb201229e7db";
authContext.handleWindowCallback();
const GlobalSettingsContainer = (props) => {
  const ConsentStatus = (appId) => {
  
    if (props.consentedApps && props.consentedApps.indexOf(appId) >= 0) {
     
      return <AcceptIcon size="large" className="succes-accept-icon" />;
    } else {
     
      return <AcceptIcon size="large" className="disabled-accept-icon" />;
    }
  };
  return (
    <div className="table-list">
      <Header
        as="h2"
        content={translate("HEEDIFY_SERVICE_APPLICATION_CONSENT")}
      />
        <Header
        style={{marginLeft:"50px" ,fontSize:"1.4em"}}
        as="h4"
        content={translate("COMMUN")}
      />
      <Flex  style={{marginLeft:"100px"}} gap="gap.large">
        <Flex.Item size="size.half">
          <Header
            className="titre-global-setting"
            as="p"
            content={translate(
              "HEEDIFY_REPORTS"
            )}
            style={{ marginRight: "0px" }}
          ></Header>
        </Flex.Item>
        <span className="close-btn">
          {ConsentStatus(reportsApp)}
          <a
            href={getAdminConsentUrl(reportsApp) +
              "&redirect_uri=" +
              ConsentReportsUrl}
            rel="noopener noreferrer"
          >
            <Button content={translate("Consent Permissons")} primary />
          </a>
        </span>
      </Flex>
      <Flex style={{marginLeft:"100px"}}>
        <Flex.Item size="size.half">
          <Header
            className="titre-global-setting"
            as="p"
            content={translate("HEEDIFY_PRESENCE")}
          ></Header>
        </Flex.Item>
        <span className="check-btn">
          {ConsentStatus(presenceAPp)}
          <a
            href={
              getAdminConsentUrl(presenceAPp) +
              "&redirect_uri=" +
              ConsentpresenceUrl
            }
            rel="noopener noreferrer"
          >
            <Button content={translate("Consent Permissons")} primary />
          </a>
        </span>
      </Flex>




      <Header
        style={{marginLeft:"50px" ,fontSize:"1.4em"}}
        as="h4"
        content={translate("EXTEND")}
      />
       <Flex  style={{marginLeft:"100px"}} gap="gap.large">
        <Flex.Item size="size.half">
          <Header
            className="titre-global-setting"
            as="p"
            content={translate(
              "HEEDIFY_CALL_CENTER"
            )}
            style={{ marginRight: "0px" }}
          ></Header>
        </Flex.Item>
        <span className="close-btn">
          {ConsentStatus(contactCenterApp)}
          <a
            href={getAdminConsentUrl(contactCenterApp) +
              "&redirect_uri=" +
              ConsentccUrl}
            rel="noopener noreferrer"
          >
            <Button content={translate("Consent Permissons")} primary />
          </a>
        </span>
      </Flex>
      <Flex  style={{marginLeft:"100px"}} >
        <Flex.Item size="size.half">
          <Header
            className="titre-global-setting"
            as="p"
            content={translate("HEEDIFY_AGENT_CONSOLE")}
          ></Header>
        </Flex.Item>
        <span className="check-btn">
          {ConsentStatus(agentConsoleApp)}
          <a
            href={
              getAdminConsentUrl(agentConsoleApp) +
              "&redirect_uri=" +
              ConsentAgentConsoleUrl
            }
            rel="noopener noreferrer"
          >
            <Button content={translate("Consent Permissons")} primary />
          </a>
        </span>
      </Flex>


      <Header
        style={{marginLeft:"50px" ,fontSize:"1.4em"}}
        as="h4"
        content={translate("TPE")}
      />
      <Flex  style={{marginLeft:"100px"}} >
        <Flex.Item size="size.half">
          <Header
            className="titre-global-setting"
            as="p"
            content={translate("HEEDIFY_AGENT_CONSOLE_UNIFY")}
          ></Header>
        </Flex.Item>
        <span className="check-btn">
          {ConsentStatus(agentConsoleUnifyApp)}
          <a
            href={
              getAdminConsentUrl(agentConsoleUnifyApp) +
              "&redirect_uri=" +
              ConsentAgentConsoleUnifyUrl
            }
            rel="noopener noreferrer"
          >
            <Button content={translate("Consent Permissons")} primary />
          </a>
        </span>
      </Flex>
      <Flex  style={{marginLeft:"100px"}} >
        <Flex.Item size="size.half">
          <Header
            className="titre-global-setting"
            as="p"
            content={translate("HEEDIFY_AGENT_CONSOLE_EUROPE")}
          ></Header>
        </Flex.Item>
        <span className="check-btn">
          {ConsentStatus(agentConsoleEuropeApp)}
          <a
            href={
              getAdminConsentUrl(agentConsoleEuropeApp) +
              "&redirect_uri=" +
              ConsentAgentConsoleEuropeUrl
            }
            rel="noopener noreferrer"
          >
            <Button content={translate("Consent Permissons")} primary />
          </a>
        </span>
      </Flex>
    
    </div>
  );
};
const mapStateToProps = (state) => ({
  consentedApps: state.consentedApps
});

const mapDispatchToProps = (dispatch) => ({
});
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(GlobalSettingsContainer);
